import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8C8.71696 8 9.41781 7.7874 10.0139 7.38908C10.6101 6.99076 11.0747 6.42461 11.3491 5.76223C11.6234 5.09985 11.6952 4.37098 11.5553 3.6678C11.4155 2.96462 11.0702 2.3187 10.5633 1.81174C10.0563 1.30477 9.41038 0.959526 8.7072 0.819655C8.00402 0.679784 7.27515 0.751571 6.61277 1.02594C5.95039 1.30031 5.38424 1.76493 4.98592 2.36106C4.5876 2.95719 4.375 3.65804 4.375 4.375C4.37596 5.33612 4.75819 6.25759 5.4378 6.9372C6.11741 7.61682 7.03888 7.99904 8 8ZM8 1.95833C8.47797 1.95833 8.94521 2.10007 9.34263 2.36562C9.74005 2.63116 10.0498 3.0086 10.2327 3.45018C10.4156 3.89177 10.4635 4.37768 10.3702 4.84647C10.277 5.31526 10.0468 5.74587 9.70884 6.08384C9.37086 6.42182 8.94026 6.65199 8.47147 6.74523C8.00268 6.83848 7.51677 6.79062 7.07518 6.60771C6.63359 6.4248 6.25616 6.11505 5.99062 5.71763C5.72507 5.32021 5.58333 4.85297 5.58333 4.375C5.58333 3.73406 5.83795 3.11937 6.29116 2.66616C6.74437 2.21295 7.35906 1.95833 8 1.95833Z"
      fill="#151718"
    />
    <path
      d="M8 9.20834C6.55838 9.20994 5.17626 9.78333 4.15687 10.8027C3.13749 11.8221 2.5641 13.2042 2.5625 14.6458C2.5625 14.8061 2.62615 14.9598 2.73946 15.0731C2.85276 15.1864 3.00643 15.25 3.16667 15.25C3.3269 15.25 3.48057 15.1864 3.59388 15.0731C3.70718 14.9598 3.77083 14.8061 3.77083 14.6458C3.77083 13.5242 4.21641 12.4485 5.00953 11.6554C5.80265 10.8622 6.87836 10.4167 8 10.4167C9.12164 10.4167 10.1974 10.8622 10.9905 11.6554C11.7836 12.4485 12.2292 13.5242 12.2292 14.6458C12.2292 14.8061 12.2928 14.9598 12.4061 15.0731C12.5194 15.1864 12.6731 15.25 12.8333 15.25C12.9936 15.25 13.1472 15.1864 13.2605 15.0731C13.3738 14.9598 13.4375 14.8061 13.4375 14.6458C13.4359 13.2042 12.8625 11.8221 11.8431 10.8027C10.8237 9.78333 9.44162 9.20994 8 9.20834Z"
      fill="#151718"
    />
  </svg>
);

const SbUserIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SbUserIcon;
